const twoFactorSetup = {
  title: "Setja upp tvíþátta auðkenningu",
  verifying: "Staðfesti...",
  enabledView: {
    title: "Tvíþátta auðkenning",
    enabledBadge: "Tvíþátta auðkenning er virkjuð",
    description: "Aðgangurinn þinn er varinn með tvíþátta auðkenningu.",
  },
  passwordStep: {
    description: "Til að virkja tvíþátta auðkenningu, staðfestu fyrst lykilorðið þitt.",
    label: "Núverandi lykilorð:",
  },
  scanStep: {
    stepLabel: "Skref 1:",
    instruction: "Skannaðu þennan QR-kóða með auðkenningarappinu þínu (Google Authenticator, Authy, o.fl.)",
    qrAlt: "QR-kóði fyrir tvíþátta auðkenningu",
    manualTitle: "Geturðu ekki skannað QR-kóðann?",
    manualLabel: "Handvirkur innsláttarkóði:",
    continueButton: "Ég hef skannað kóðann",
  },
  verifyStep: {
    stepLabel: "Skref 2:",
    instruction: "Sláðu inn 6 stafa kóðann úr auðkenningarappinu þínu",
    label: "Staðfestingarkóði:",
    placeholder: "000000",
    submit: "Virkja tvíþátta auðkenningu",
  },
  errors: {
    setupFailed: "Ekki tókst að setja upp tvíþátta auðkenningu",
    invalidCode: "Ógildur staðfestingarkóði",
  },
};

export default twoFactorSetup;
